import { useEffect, useState } from "react";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import styles from "./Downloads.module.scss";
import { tempReturnObject as DateRangeOptions, intelAPIEndpoints } from "@routes/intel/dashboard/const";
import axios from "axios";
import moment from "moment";
import IntelLayout from "@components/layout/layout";
import DateRangePickerSelfComponent from "@components/date-range-picker/date-range-picker";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import ReactCountryFlag from "react-country-flag";
import ReactTooltip from "react-tooltip";
import { Filters } from "@components/templates/Filters";
import { titleCaseDataSource, getTitleCase } from "@utils/utils";
import { CircularProgressbar } from "react-circular-progressbar";
import commaFormat from "@utils/commaFormat";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { CountryCodeOneToOneMap } from "@core/dictionary/global";
const sortEnum = [
  { columnKey: "date", value: "date" },
  { columnKey: "records", value: "records" },
  { columnKey: "credits", value: "credits" },
];
const DashboardDownload = () => {
  const location = useLocation();
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloadData, setDownloadData] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [reqPayload, setReqPayload] = useState({});
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [selectedDateRange, setSelectedDateRange] = useState({ from: "", to: "" });
  const [sortField, setSortField] = useState(sortEnum[0].value);
  const [sortOrderValue, setSortOrderValue] = useState("desc");
  const [downloadCount, setDownloadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [downloadCredits, setDownloadCredits] = useState({ totalCredit: 0, usedCredit: 0 });
  const userPlan = useSelector((state) => state?.userDetails?.creditDetails?.data?.[0]?.user_active_plan);
  useEffect(() => {
    let payload = createPayload();
    getDownloadData(payload);
  }, []);

  const column = [
    {
      name: "S. No",
      maxWidth: "50px !important",
      minWidth: "50px !important",
      selector: (row) => <div>{row?.s_no}</div>,
    },
    {
      name: "Download Date",
      wrap: true,
      sortable: true,
      key: "date",
      maxWidth: "100px !important",
      minWidth: "100px !important",
      selector: (row) => <div>{(row.downloaded_at && moment(row.downloaded_at, "DD-MM-YYYY").format("MMM DD, YYYY")) || <span className={`${styles.column_no_data}`}>NA</span>}</div>,
    },
    {
      name: "File Name",
      maxWidth: "160px !important",
      minWidth: "160px !important",
      selector: (row, index) => (
        <>
          <div data-for={row.file_name + index} data-tip={row.file_name?.length > 27 ? row.file_name : ""}>
            {row?.file_name?.slice(0, 27) || <span className={`${styles.column_no_data}`}>NA</span>}
            {row?.file_name?.length > 27 && "..."}
          </div>
          <ReactTooltip id={row.file_name + index} className="trademo-tooltip" textColor="#FFFFFF" place="bottom" />
        </>
      ),
    },
    {
      name: "Source",
      maxWidth: "180px !important",
      minWidth: "180px !important",
      selector: (row) => (
        <div className="d-flex">
          {(row?.download_type && (
            <span data-for={row.file_name + row.download_type} data-tip={row.download_type?.length > 27 ? getTitleCase(row.download_type) + (row?.data_set ? ` - ${titleCaseDataSource(row.data_set)}` : "") : ""} style={{ backgroundColor: row?.bgColor || "#fdf2fa" }} className={`text-capitalize ${styles.download_type}`}>
              {row.download_type.slice(0, 27).toLowerCase()}
              {row.download_type?.length > 27 && "..."} {row?.data_set && " - "} {(row?.country.toLowerCase() === "us mirror imports" && "US Imports (Non-Maritime)") || (row?.country.includes("maritime") && row?.data_set) || (row?.country.toLowerCase() === "us mirror exports" && "US Exports (Non-Maritime)") || (row?.country.toLowerCase() === "russia nm imports" && "Russia Imports") || (row?.country.toLowerCase() === "russia nm exports" && "Russia Exports") || (row?.country.toLowerCase() === "indonesia nm imports" && "Indonesia Imports") || (row?.country.toLowerCase() === "indonesia nm exports" && "Indonesia Exports") || row.data_set || ""}
              {row.country_code && row?.data_set ? row.country_code === "middleeast" ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg" className="tw-h-3.5 tw-w-3.5 tw-ml-1" /> : CountryCodeOneToOneMap[row.country_code.toLowerCase()] ? <ReactCountryFlag className="ml-1" countryCode={CountryCodeOneToOneMap[row.country_code.toLowerCase()]} svg /> : <ReactCountryFlag className="ml-1" countryCode={row.country_code} svg /> : <></>}
            </span>
          )) || <span className={`${styles.column_no_data}`}>NA</span>}
          <ReactTooltip id={row.file_name + row.download_type} className="trademo-tooltip" textColor="#FFFFFF" place="bottom" />
        </div>
      ),
    },
    {
      name: "Records",
      wrap: true,
      key: "records",
      sortable: true,
      maxWidth: "80px !important",
      minWidth: "80px !important",
      selector: (row) => <div>{row?.records || <span className={`${styles.column_no_data}`}>NA</span>}</div>,
    },
    {
      name: "Credits Used",
      sortable: true,
      key: "credits",
      maxWidth: "80px !important",
      minWidth: "80px !important",
      selector: (row) => <div>{row?.credits || <span className={`${styles.column_no_data}`}>NA</span>}</div>,
    },
    {
      name: "",
      wrap: true,
      maxWidth: "30px !important",
      minWidth: "30px !important",
      selector: (row) => (
        <div
          className="cursor-pointer"
          onClick={() => {
            trademoTrackingEvents(trackingEventDictionary.dashboardDownloadsRedownload, { ...generateTrackingObject(location.pathname) });
            downloadFile(row?.file_download_uri);
          }}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="M260-180q-82.92 0-141.46-57.62Q60-295.23 60-378.15q0-73.39 47-130.54 47-57.16 119.92-67.62 13.54-73.15 79.81-136.8Q373-776.77 450-776.77q24.54 0 42.27 17.73Q510-741.31 510-716.77v266.62l73.23-72L625.38-480 480-334.62 334.62-480l42.15-42.15 73.23 72v-266.62q-75.61 8.62-122.81 69.46Q280-586.46 280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-48.77-22-90.27-22-41.5-58-69.73v-70.31q65.15 33.08 102.58 95.23Q740-592.92 740-520v20h12.31q63.23 4.92 105.46 50.85Q900-403.23 900-340q0 66.92-46.54 113.46Q806.92-180 740-180H260Zm220-328.38Z" />
          </svg>
        </div>
      ),
    },
  ];

  const downloadFile = (url) => {
    axios.get(intelAPIEndpoints.getDownloadShipments, { params: { file_name: url } }).then((res) => {
      if (res?.data?.data?.file_url) {
        window.open(res.data.data.file_url);
      }
    });
  };
  const createPayload = () => {
    let payload = {
      section_type: "downloads",
      from: 0,
      sort: sortField,
      sort_order: sortOrderValue,
      from_date: selectedDateRange.from,
      to_date: selectedDateRange.to,
      filter: {
        "download type": [],
        dataset: [],
      },
    };
    if (reqPayload?.filter && Object.keys(reqPayload.filter)?.length) {
      for (const [key, value] of Object.entries(reqPayload.filter)) {
        payload.filter[key] = [...value];
      }
    }
    return payload;
  };

  const mapFilterData = (data, payload) => {
    if (!payload.from_date && !payload.from_date) {
      setFilterData(data);
    }
  };

  const getDownloadData = (payload) => {
    setReqPayload({ ...payload, filters: { ...payload.filter } });
    setIsLoading(true);
    axios
      .post(intelAPIEndpoints.getDasboardAPI, payload)
      .then((res) => {
        mapFilterData(res?.data?.downloadHistoryResponse?.filter || {}, payload);
        if (payload.from === 0) {
          setDownloadData(res?.data?.downloadHistoryResponse?.data || []);
        } else {
          setDownloadData([...downloadData, ...res.data.downloadHistoryResponse.data]);
        }
        setDownloadCount(res?.data?.downloadHistoryResponse?.total_count || 0);
        if (!payload.from_date || !payload.to_date) {
          setDownloadCredits({ totalCredit: res.data.downloadHistoryResponse?.downloads_max_allowed || 0, usedCredit: res.data.downloadHistoryResponse?.downloads_current_count || 0 });
          setDateRange(JSON.parse(JSON.stringify({ from: res.data.downloadHistoryResponse.from_date, to: res.data.downloadHistoryResponse.to_date })));
          setSelectedDateRange(JSON.parse(JSON.stringify({ from: res.data.downloadHistoryResponse.from_date, to: res.data.downloadHistoryResponse.to_date })));
        }
      })
      .finally(() => setIsLoading(false));
  };

  const applyFilter = (filterKey, data, clearType) => {
    let payload = createPayload();
    setCurrentPage(1);
    if (clearType) {
      if (clearType === "clearAll") {
        Object.keys(payload.filter).forEach((key) => {
          payload.filter[key] = [];
        });
      } else {
        payload.filter[filterKey] = [];
      }
    } else {
      if (payload.filter[filterKey]?.includes(data.key)) {
        let index = payload.filter[filterKey].indexOf(data.key);
        payload.filter[filterKey].splice(index, 1);
      } else {
        payload.filter[filterKey] = [...payload.filter[filterKey], data.key];
      }
    }
    getDownloadData(payload);
  };

  const handleDateChange = (dateRange) => {
    let tempDateRange = { from: moment(dateRange.startDate).format("DD-MM-YYYY"), to: moment(dateRange.endDate).format("DD-MM-YYYY") };
    setSelectedDateRange(tempDateRange);
    setCurrentPage(1);
    let payload = createPayload();
    payload.from_date = tempDateRange.from;
    payload.to_date = tempDateRange.to;
    getDownloadData(payload);
  };
  const handlePageChange = (page, perPage) => {
    if (downloadCount > page * perPage) {
      let payload = createPayload();
      payload.from = downloadData.length;
      getDownloadData(payload);
    }
    setCurrentPage(page);
    setPerPage(perPage);
  };
  const handleSorting = (column, sortDirection) => {
    setCurrentPage(1);
    setSortField(column);
    setSortOrderValue(sortDirection);
    let payload = createPayload();
    payload.sort = column;
    payload.sort_order = sortDirection;
    getDownloadData(payload);
  };

  const clearFilter = () => {
    let payload = createPayload();
    payload.filter = {
      "download type": [],
      dataset: [],
    };
    payload.from_date = "";
    payload.to_date = "";
    setSelectedDateRange({ from: "", to: "" });
    setDateRange({ from: "", to: "" });
    getDownloadData(payload);
  };

  return (
    <IntelLayout
      type={"downloadHistory"}
      pageTitle="Downloads | Trademo Intel"
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}>
      <div>
        <div className="d-flex pt-2 d-flex justify-content-between align-items-center">
          {isLoading && !dateRange.from ? (
            <LoadingSkeleton lines={1} lineHeight={"36px"} width={"240px"} shape="rectangle" />
          ) : (
            <div className="d-flex align-items-center">
              {dateRange.from && dateRange.to && selectedDateRange?.from && selectedDateRange?.to && (
                <span className={styles.date_picker_container}>
                  <svg className={styles.calendar_icon} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
                    <path d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600v-430H180v430Zm0-490h600v-130H180v130Zm0 0v-130 130Zm300 230q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                  </svg>
                  <DateRangePickerSelfComponent
                    initialSettings={{
                      startDate: moment(selectedDateRange?.from, "DD-MM-YYYY"),
                      endDate: moment(selectedDateRange?.to, "DD-MM-YYYY"),
                      maxDate: moment(dateRange?.to, "DD-MM-YYYY"),
                      minDate: moment(dateRange?.from, "DD-MM-YYYY"),
                      linkedCalendars: false,
                      showDropdowns: true,
                      alwaysShowCalendars: true,
                      applyButtonClasses: "btn btn-primary btn-sm trademo-new-btn",
                      cancelButtonClasses: "btn btn-outline-secondary trademo-outline-btn btn-sm py-2",
                      ranges: DateRangeOptions,
                      opens: "right",
                      locale: {
                        format: "MMM D, YYYY",
                        separator: " - ",
                      },
                    }}
                    customClassName={styles.date_picker}
                    onApply={(e) => handleDateChange(e)}
                  />
                </span>
              )}
              {dateRange.from && dateRange.to && (
                <div className="ml-3">
                  <Filters
                    filterData={filterData}
                    payload={reqPayload}
                    onChangeHandler={(data, filter, clearType) => {
                      applyFilter(data, filter, clearType);
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {!userPlan?.includes("enterprise") && downloadCredits.totalCredit > 0 && downloadCredits.usedCredit >= 0 && (
            <div className={styles.circular_bar_text}>
              <span className="font-weight-bold">{commaFormat(downloadCredits.totalCredit - downloadCredits.usedCredit)} </span> of <span> {commaFormat(downloadCredits.totalCredit)} </span> download credits remaining
              <CircularProgressbar value={((downloadCredits.totalCredit - downloadCredits.usedCredit) / downloadCredits.totalCredit) * 100} strokeWidth={15} className={styles.circular_progress_bar} />
            </div>
          )}
        </div>
        <div className="mt-3">
          {isLoading ? (
            <LoadingSkeleton lines={10} lineHeight={"40px"} width={"100%"} shape="rectangle" widthArr={["100%", "100%", "100%", "100%"]} />
          ) : downloadData.length ? (
            <ReactTableTrademo
              columns={column}
              data={downloadData}
              onSelectedRowsChange={() => null}
              paginationTotalRows={downloadCount}
              paginationPerPage={perPage}
              paginationDefaultPage={currentPage}
              selectedData={[]}
              onChangeRowsPerPage={(data) => {
                setPerPage(data);
              }}
              onTableObjectChange={(data) => {
                setPerPage(data.perPage);
                setCurrentPage(data.currentPage + 1);
              }}
              onChangePage={(page, perPage) => {
                handlePageChange(page, perPage);
              }}
              hideSorting={true}
              onSort={(column, sortDirection) => {
                handleSorting(column, sortDirection);
              }}
              defaultSortField={sortField}
              defaultSortAsc={sortOrderValue === "desc" ? false : true}
              shipmentDefaultSortValue={sortEnum}
              sortOrderValue={sortOrderValue}
              hideBorder={true}
              hideSelection
            />
          ) : (
            <div className={`${styles.no_data_column_data} text-center`}>
              <img className="py-2" src={CLOUDINARY_INTEL_BASE_URL + "/v1670225921/intel/icons/no_result_illustration_avz4aw.svg"} />
              {dateRange.from && dateRange.to ? (
                <>
                  <p className="py-2">We couldn't find any matches based on your selected filters.</p>
                  <button
                    onClick={() => {
                      clearFilter();
                    }}
                    className="btn btn-primary btn-sm trademo-new-btn">
                    Clear Filter
                  </button>
                </>
              ) : (
                <>
                  <p className="py-2">Your downloaded files will appear here along with the credits utilised..</p>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </IntelLayout>
  );
};
export default DashboardDownload;
